export default {"src":"/_next/static/media/logo_hoopcare.98b8566e.svg","height":1500,"width":1500,"blurWidth":0,"blurHeight":0};